import React from 'react'
import { Logger } from 'wdc-cube'

import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Tooltip from '@mui/material/Tooltip'

import AccountTreeIcon from '@mui/icons-material/AccountTree'
import AutoGraphIcon from '@mui/icons-material/AutoGraph'
import AutoModeIcon from '@mui/icons-material/AutoMode'
import CorporateFareIcon from '@mui/icons-material/CorporateFare'
import PeopleIcon from '@mui/icons-material/People'
import PriceCheckIcon from '@mui/icons-material/PriceCheck'
import ReceiptIcon from '@mui/icons-material/Receipt'
import ScreenSearchDesktopIcon from '@mui/icons-material/ScreenSearchDesktop'
import TroubleshootIcon from '@mui/icons-material/Troubleshoot'

import { FCClassContext, classToFComponent } from 'src/utils/views'
import { MainScope } from '../../Main.scopes'

const LOG = Logger.get('DrawerContent')

export type DrawerContentProps = {
    className?: string
    mainScope: MainScope
}

class DrawerContentClass implements FCClassContext<DrawerContentProps> {
    // :: Fields

    scope!: MainScope

    // :: emissors

    readonly emitPJ = () => this.scope.onPJ().catch(LOG.caught)
    readonly emitPF = () => this.scope.onPF().catch(LOG.caught)
    readonly emitSerasa = () => this.scope.onSerasa().catch(LOG.caught)
    readonly emitSerasaHistory = () => this.scope.onSerasaHistory().catch(LOG.caught)
    readonly emitSerpro = () => this.scope.onSerpro().catch(LOG.caught)
    readonly emitGrupo = () => this.scope.onGrupo().catch(LOG.caught)
    readonly emitAnalise = () => this.scope.onAnalise().catch(LOG.caught)
    readonly emitMonitoramento = () => this.scope.onMonitoramento().catch(LOG.caught)
    readonly emitBordero = () => this.scope.onBordero().catch(LOG.caught)

    // :: Methods

    onSyncState({ mainScope }: DrawerContentProps) {
        this.scope = mainScope
    }

    render() {
        const { scope } = this

        return (
            <List component="nav">
                {scope.pjEnabled && (
                    <ListItemButton onClick={this.emitPJ}>
                        <Tooltip title="Pessoa Jurídica">
                            <ListItemIcon>
                                <CorporateFareIcon />
                            </ListItemIcon>
                        </Tooltip>
                        <ListItemText primary="Pessoa Jurídica" />
                    </ListItemButton>
                )}
                {scope.pfEnabled && (
                    <ListItemButton onClick={this.emitPF}>
                        <Tooltip title="Pessoa Física">
                            <ListItemIcon>
                                <PeopleIcon />
                            </ListItemIcon>
                        </Tooltip>
                        <ListItemText primary="Pessoa Física" />
                    </ListItemButton>
                )}
                {scope.serasaEnabled && (
                    <ListItemButton onClick={this.emitSerasa}>
                        <Tooltip title="Serasa">
                            <ListItemIcon>
                                <PriceCheckIcon />
                            </ListItemIcon>
                        </Tooltip>
                        <ListItemText primary="Serasa" />
                    </ListItemButton>
                )}
                {scope.serasaHistoryEnabled && (
                    <ListItemButton onClick={this.emitSerasaHistory}>
                        <Tooltip title="Histórico Consultas Serasa">
                            <ListItemIcon>
                                <TroubleshootIcon />
                            </ListItemIcon>
                        </Tooltip>
                        <ListItemText primary="Histórico Consultas Serasa" />
                    </ListItemButton>
                )}                
                {scope.serproEnabled && (
                    <ListItemButton onClick={this.emitSerpro}>
                        <Tooltip title="Serpro">
                            <ListItemIcon>
                                <ReceiptIcon />
                            </ListItemIcon>
                        </Tooltip>
                        <ListItemText primary="Serpro" />
                    </ListItemButton>
                )}
                {scope.analiseEnabled && (
                    <ListItemButton onClick={this.emitAnalise}>
                        <Tooltip title="Análise">
                            <ListItemIcon>
                                <AutoGraphIcon />
                            </ListItemIcon>
                        </Tooltip>
                        <ListItemText primary="Análise" />
                    </ListItemButton>
                )}
                {scope.grupoEnabled && (
                    <ListItemButton onClick={this.emitGrupo}>
                        <Tooltip title="Grupo Análise">
                            <ListItemIcon>
                                <AccountTreeIcon />
                            </ListItemIcon>
                        </Tooltip>
                        <ListItemText primary="Grupo Análise" />
                    </ListItemButton>
                )}
                {scope.monitoramentoEnabled && (
                    <ListItemButton onClick={this.emitMonitoramento}>
                        <Tooltip title="Monitoramento">
                            <ListItemIcon>
                                <ScreenSearchDesktopIcon />
                            </ListItemIcon>
                        </Tooltip>
                        <ListItemText primary="Monitoramento" />
                    </ListItemButton>
                )}
                {scope.borderoEnabled && (
                    <ListItemButton onClick={this.emitBordero}>
                        <Tooltip title="Borderô">
                            <ListItemIcon>
                                <AutoModeIcon />
                            </ListItemIcon>
                        </Tooltip>
                        <ListItemText primary="Borderô" />
                    </ListItemButton>
                )}
            </List>
        )
    }
}

export default classToFComponent(DrawerContentClass)
